import type { RateCacheEntry, RateSource } from '@/types/domain'
import { useRateCacheStore } from './zustand-store'

export interface RateCacheLookup {
  source: RateSource
  series: string
  date: string
}

/** Returns the cache entry that exactly matches `(source, series, date)` or undefined. */
export function getRate(lookup: RateCacheLookup): RateCacheEntry | undefined {
  return useRateCacheStore
    .getState()
    .rates.find(
      (r) => r.source === lookup.source && r.series === lookup.series && r.date === lookup.date,
    )
}

/** Inserts or updates a single cache entry. */
export function putRate(entry: RateCacheEntry): void {
  useRateCacheStore.getState().upsert(entry)
}

/** Inserts or updates many cache entries in a single pass. */
export function putRates(entries: RateCacheEntry[]): void {
  useRateCacheStore.getState().bulkUpsert(entries)
}

/** Removes every cached rate. Snapshots in `Entry.snapshot` remain intact. */
export function clearRates(): void {
  useRateCacheStore.getState().clear()
}

/** Total number of cached entries — surfaced in Settings UI for transparency. */
export function rateCount(): number {
  return useRateCacheStore.getState().rates.length
}
